/** @jsx jsx */
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { Container, Row } from '../../../styles/Grid';
import OffsetColumn from '../../ui/OffsetColumn';
import Picture from '../../ui/Picture';
import Spacer from '../../ui/Spacer';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import {
  containerMarginCss,
  containerPaddingCss,
  Content,
  QuoteText,
  InitialQuote,
  Footer,
  PictureContainer,
  pictureCss,
  imageCss,
  FooterText,
  AttributionMainText,
  AttributionSecondaryText,
} from './index.styles';

class Quote extends SafePureComponent {
  safeRender() {
    const { fields } = this.props;
    const hasImage = !isEmpty(get(fields, 'Headshot.value', {}));

    return (
      <Spacer
        backgroundColor={fields.BackgroundColor}
        marginCss={containerMarginCss}
        paddingCss={containerPaddingCss}
      >
        <Container>
          <Row>
            <OffsetColumn cols={{ lg: 6 }} offsets={{ md: 1, lg: 2, xl: 2 }}>
              <Content>
                <QuoteText>
                  <InitialQuote>“</InitialQuote>
                  <Text field={fields.QuoteText} />
                  {'”'}
                </QuoteText>
                <Footer>
                  {hasImage && (
                    <PictureContainer>
                      <Picture
                        image={fields.Headshot}
                        pictureCss={pictureCss}
                        imageCss={imageCss}
                      />
                    </PictureContainer>
                  )}
                  <FooterText>
                    <AttributionMainText>
                      <Text field={fields.AttributionMainText} />
                    </AttributionMainText>
                    <AttributionSecondaryText>
                      <Text field={fields.AttributionSecondaryText} />
                    </AttributionSecondaryText>
                  </FooterText>
                </Footer>
              </Content>
            </OffsetColumn>
          </Row>
        </Container>
      </Spacer>
    );
  }
}

Quote.displayName = 'Quote';

Quote.propTypes = {
  fields: PropTypes.shape({
    QuoteText: PropTypes.any,
    AttributionMainText: PropTypes.any,
    AttributionSecondaryText: PropTypes.any,
    Headshot: PropTypes.any,
    BackgroundColor: PropTypes.any,
  }),
};

export default Quote;
